module.exports = __webpack_public_path__ + "img/img15.5e229f14.svg";